<template>
<div class="nkn-about">
  <div class="nkn-container">
    <about-header></about-header>
  </div>
  <div class="nkn-container" id="#team">
    <about-member></about-member>
  </div>
  <div class="nkn-container">
    <about-advisor></about-advisor>
  </div>

    <div class="partner-portal" id="#partner">
      <div class="common-title">{{$t("partner.title")}}</div>
      <div class="nkn-container">
        <partner-topology-graph></partner-topology-graph>
      </div>
      <div class="nkn-container">
        <partner-more></partner-more>
      </div>
      <div class="nkn-container">
        <partners-module></partners-module>
      </div>
      <div class="nkn-container">
        <about-partner></about-partner>
      </div>
    </div>

  <div class="nkn-container" id="#roadmap">
      <about-roadmap></about-roadmap>
    </div>
  <div class="nkn-container">
    <about-texture></about-texture>
  </div>
</div>
</template>

<script>
import AboutHeader from '@/components/about/AboutHeader'
import AboutMember from '@/components/about/nknCoreTeam'
import AboutAdvisor from '@/components/about/nknAdvisor'
import AboutRoadmap from '@/components/about/nknRoadmap'
import AboutPartner from '@/components/about/nknPartner'
import AboutTexture from '@/components/about/nknTexture'
import PartnerTopologyGraph from '@/components/partner/TopologyGraph'
import PartnersModule from '@/components/partner/nknPartners'
import PartnerMore from '@/components/partner/nknMore'

export default {
  components: {
    AboutHeader,
    AboutMember,
    AboutRoadmap,
    AboutPartner,
    AboutTexture,
    AboutAdvisor,
    PartnerTopologyGraph, PartnersModule, PartnerMore, AboutPartner
  },
  metaInfo() {
    if (this.$i18n.locale === 'zh') {
      return {
        title: '关于NKN',
        // titleTemplate: '%s - by vue-meta',
        htmlAttrs: {
          lang: this.$i18n.locale
        },
        attribute: '',
        meta: [
          {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
          {
            name: 'description',
            content: 'NKN项目介绍、团队和产品路线表NKN。'
          }
        ]
      }
    } else {
      return {
        title: 'About NKN | The New Kind of Network',
        // titleTemplate: '%s - by vue-meta',
        htmlAttrs: {
          lang: this.$i18n.locale
        },
        meta: [
          {name: 'keywords', content: 'NKN,nkn,P2P,Network,BlockChain'},
          {
            name: 'description',
            content: 'We\'re shaping the future of the internet through the world\'s largest decentralized blockchain network. Learn more about our team, background, and roadmap.'
          }
        ]
      }
    }

  }
}
</script>

<style lang="scss" scoped>
.nkn-container:nth-child(even) {
  background-color: #f9faff;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/AboutPortal.vue